import { useZoom } from '../hooks'

const Zoom = ({ mapId }) => {
  const [zoom, { zoomIn, zoomOut }] = useZoom(mapId)

  return (
    <>
      <button className="map--zoom-in" onClick={zoomIn}><img src="images/plus-icon.svg" alt="plus icon" /></button>
      <button className="map--zoom-out" onClick={zoomOut}><img src="images/minus-icon.svg" alt="minus icon" /></button>
    </>
  )
}

export default Zoom